import { documents } from "@/mocks/documentos";
import DocumentTypeBadge from "./DocumentTypeBadge";
import DocumentStatusBadge from "./DocumentStatusBadge";

interface TreeSourcesTableProps {
  onViewDocument: (id: string) => void;
}

const treeDocs = documents.filter((d) => d.ctaCode !== null);

export default function TreeSourcesTable({ onViewDocument }: TreeSourcesTableProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Documentos vinculados a indivíduos arbóreos</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 text-left">
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Código CTA</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Espécie</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Tipo de fonte</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Documento</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Vistoria</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Status</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Data</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Ações</th>
            </tr>
          </thead>
          <tbody>
            {treeDocs.map((doc) => (
              <tr key={doc.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3">
                  <span className="text-sm font-mono font-semibold text-foreground-800">{doc.ctaCode}</span>
                </td>
                <td className="py-2.5 px-3 text-xs text-foreground-500">
                  {doc.ctaCode === "CTA-GO-001" ? "Mangifera indica" :
                   doc.ctaCode === "CTA-GO-002" ? "Caesalpinia pluviosa" :
                   doc.ctaCode === "CTA-GO-004" ? "Cedrela fissilis" :
                   doc.ctaCode === "CTA-GO-006" ? "Hymenaea courbaril" :
                   doc.ctaCode === "CTA-GO-008" ? "Tabebuia roseoalba" :
                   doc.ctaCode === "CTA-GO-012" ? "Tapirira guianensis" :
                   doc.ctaCode === "CTA-GO-013" ? "Psidium guajava" : "—"}
                </td>
                <td className="py-2.5 px-3"><DocumentTypeBadge type={doc.type} /></td>
                <td className="py-2.5 px-3">
                  <button onClick={() => onViewDocument(doc.id)} className="text-sm font-medium text-foreground-800 hover:text-accent-600 transition-colors text-left max-w-[200px] truncate block">
                    {doc.title}
                  </button>
                </td>
                <td className="py-2.5 px-3 text-xs text-foreground-500">{doc.inspectionId ? `#${doc.inspectionId}` : "—"}</td>
                <td className="py-2.5 px-3"><DocumentStatusBadge status={doc.status} /></td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 whitespace-nowrap">{doc.issueDate}</td>
                <td className="py-2.5 px-3">
                  <div className="flex items-center gap-1">
                    <button onClick={() => onViewDocument(doc.id)} className="w-7 h-7 rounded-md hover:bg-background-100 flex items-center justify-center text-foreground-500 hover:text-accent-600 transition-colors" title="Visualizar">
                      <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}